module.exports = __webpack_public_path__ + "img/anli-4.235063eb.png";